import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'


export const BuyerListing = ({ buyerFilteringData, handleClick, editEnabled }) => {

    const [buyerFiltering, setBuyerFiltering] = useState([]);

    const contentRowNames = ["buyerName","buyerCode","businessRegNo", "contactNumber", "isActive"]

    useEffect(() => {
        trackPromise(
            setBuyerFilteringData()
        )
    }, [buyerFilteringData]);

    async function setBuyerFilteringData() {
        destroyDataTable();
        await setBuyerFiltering(buyerFilteringData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#buyerTable').DataTable().destroy();
    }

    function createDataTable() {
        $('#buyerTable').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                        <table id="buyerTable" className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Buyer Name</th>
                                    <th>Buyer Code</th>
                                    <th>Business RegNo</th>
                                    <th>Telephone</th>
                                    <th>Status</th>
                                    {editEnabled ? <th>Action</th> : null}
                                </tr>
                            </thead>
                            <tbody>
                                {buyerFiltering.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            {editEnabled ? <td
                                                onClick={() => handleClick(data)}
                                                style={{ cursor: "pointer" }}>
                                                <i className="far fa-edit"></i>
                                            </td> : null}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


